import React, { Component } from 'react';
import Layout from "../Layout";
import { Select, Button, Input, Textarea, Checkbox, DatePicker, Radio } from "~/js/partials";
import { isInitialValid, processMakes, processModels, filterModelsByMake, groupDealerships, formatGroupLabel } from "~/js/utils";
import { Formik, Form } from 'formik';
import * as Yup from 'yup';
import { formsService } from '~/js/_services';
import Turnstile from "react-turnstile";

const makes = processMakes(window.makes_data);

// Regions & dealership data for form population
let dealershipsGrouped = [];

class FormBookService extends Component {

    state = {
        makeID: null,
        formDealerID: null,
        turnstileToken : "",
        dealerships: dealershipsGrouped,
        selectedBrand: null,
    };

    updateDealers = () => {
        let matchingDealerIDs = [];
        let availableDealershipId = [];
        if(window.available_dealerships && window.available_dealerships.length > 1){
            window.available_dealerships.forEach(dealer => {
                availableDealershipId.push(dealer['ID']);
            })
        }
        dealershipsGrouped.forEach(region => {
            if(region.options){
                region.options.forEach(dealer => {
                    if(availableDealershipId.length > 1){
                        if (dealer.dealer['ID']) {
                            if(availableDealershipId.includes(dealer.dealer['ID'])){
                                matchingDealerIDs.push(dealer.dealer.ID);
                            }
                        }
                    }else if(this.state.selectedBrand){
                        if (dealer.dealer.data['dealership-details'] && dealer.dealer.data['dealership-details'].brand) {
                            if (dealer.dealer.data['dealership-details'].brand.find(br => (br.ID == this.state.selectedBrand.id))) {
                                matchingDealerIDs.push(dealer.dealer.ID);
                            }
                        }
                        if (dealer.dealer.data['dealership-details'] && dealer.dealer.data['dealership-details']['other-brand']) {
                            if (dealer.dealer.data['dealership-details']['other-brand'].find(br => (br.ID == this.state.selectedBrand.id))) {
                                matchingDealerIDs.push(dealer.dealer.ID);
                            }
                        }
                    }
                })
            }
        })

        let clonedDealers = JSON.parse(JSON.stringify(dealershipsGrouped))

        clonedDealers.forEach(region => {
            if(region.options){
                let newOptions = [];
                region.options.forEach((dealer, i) => {
                    if (matchingDealerIDs.includes(dealer.dealer.ID)){
                        newOptions.push(region.options[i])
                    }
                })
                region.options = newOptions
            }
        })

        // reset clonedDealers if theres none in there
        let foundDealers = false;
        clonedDealers.forEach(region => {
            if(region.options && region.options.length > 0){
                foundDealers = true;
            }
        })
        if(foundDealers){
            if(this.state.selectedBrand){
                clonedDealers[0].label = `Select from ${this.state.selectedBrand.label } Dealerships`
            }
        }else{
            clonedDealers = JSON.parse(JSON.stringify(dealershipsGrouped))
        }

        this.setState({dealerships: clonedDealers})
    };

    componentDidMount(){
        dealershipsGrouped = groupDealerships(this.props.regions);
        this.checkForm();
    }

    componentDidUpdate(prevProps){
        // Check if type is updated, once component is mounted
        // In case of clicking test-drive generic straight after test-drive-branded
        if (this.props.type !== prevProps.type) {
            // Reset form is type changed
            if (this.formik) this.formik.resetForm();
            this.checkForm();
        }
    }

    checkForm = () => {
        const { brand, dealer } = this.props;

        // Preselect brand / region if it's passed as a prop
        if (brand) {
            if (this.formik) this.formik.setFieldValue('brand', brand['name']);
            this.setState({ makeID: brand['id'], selectedBrand: brand }, () => {
                this.updateDealers();
            });
        } else {
            this.setState({ makeID: null, selectedBrand: null }, () => {
                this.updateDealers();
            });
        }

        if (dealer) {
            if (this.formik) this.formik.setFieldValue('dealer', dealer['post_title']);
            this.setState({ formDealerID: dealer['ID'] });
        } else {
            this.setState({ formDealerID: null });
        }
    };

    handleSubmit = (fields, { setStatus, setSubmitting }) => {
        const { showSuccessPopup } = this.props;
        setStatus();

        let turnstileData = {
            response: this.state.turnstileToken,
        }
        formsService.turnstileVerification(turnstileData).then((response) => {
            if(response.data.success) {
        let data = {
            name: 'Book Service',
            fields: JSON.parse(JSON.stringify(fields))
        };

        if (this.state.formDealerID) {
            data.fields.formDealerID = this.state.formDealerID;
        }

        formsService.bookService(data).then(
            success => {
                const title = "Your submission is successful"
                const text = "We will contact you about your booking."
                setSubmitting(false);
                showSuccessPopup({ title, text });
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'FormSubmit',
                    'formType': this.props.type,
                    'formBrand': data.fields.brand,
                    'formModel': data.fields.model,
                    'formRegion': data.fields.myRegion,
                    'formDealership': data.fields.dealer ? data.fields.dealer : null,
                    'formKm0': null,
                    'formVehicleRegistration': data.fields.vehicleRegistration
                });
            },
            error => {
                setSubmitting(false);
                setStatus(error.message);
            });
        } else{
            setSubmitting(false);
            setStatus("Error with Turnstile Verification");
        }
        });

    };

    get isNoDealer() {
        return this.props.type === 'book-service-no-dealer';
    };

    renderForm = (props) => {
        const { brand, dealer } = this.props;
        const { isValid, isSubmitting, status } = props;

        let extraClass = window.dealerSlug ? `form-book-service-${window.dealerSlug}` : `form-book-service`;
        if (this.isNoDealer) {
            extraClass =  `form-book-service`;
        }

        return (
            <Form className="popup-form__form">
                <div className="popup-form__group">
                    <div className="popup-form__label">Vehicle details</div>

                    <div className="popup-form__row">
                        <div className="popup-form__col">
                            <Input
                                name={`vehicleRegistration`}
                                placeholder={`Vehicle Registration (optional)`}
                                modifiers={['form']}
                                form={props}
                            />
                        </div>
                    </div>

                    <div className="popup-form__row">
                        <div className="popup-form__col">
                            <Select
                                name={`brand`}
                                form={props}
                                options={makes}
                                onChange={({ id }) => {
                                    if (id !== this.state.makeID) {
                                        this.setState({ makeID: id })
                                    }
                                }}
                                isDisabled={brand ? true : false}
                                modifiers={['form']}
                            />
                        </div>

                        <div className="popup-form__col">
                            <Input
                                name={`model`}
                                placeholder={`Model (optional)`}
                                modifiers={['form']}
                                form={props}
                            />
                        </div>
                    </div>
                </div>

                <div className="popup-form__group">
                    <div className="popup-form__row">
                        <div className="popup-form__col">
                            <Checkbox
                                label={{ text: 'I’d like to request a loan vehicle during my service'}}
                                name={`isLoanVehicle`}
                                form={props}
                            />
                        </div>
                    </div>
                </div>


                <div className="popup-form__group">
                    <div className="popup-form__label">Booking details</div>

                    <div className="popup-form__row">
                        <div className="popup-form__col">
                            <Select
                                name={`dealer`}
                                form={props}
                                options={this.state.dealerships}
                                onChange={(dealer) => {
                                    let id = dealer.dealer ? dealer.dealer.ID : null
                                    if (id !== this.state.formDealerID) {
                                        this.setState({ formDealerID: id })
                                    }
                                }}
                                isDisabled={dealer ? true : false}
                                formatGroupLabel={formatGroupLabel}
                                modifiers={['form']}
                            />
                        </div>
                    </div>

                    <div className="popup-form__row">
                        <div className="popup-form__col">
                            <DatePicker
                                name="date"
                                placeholderText="Select preferred date"
                                form={props}
                                modifiers={['form']}
                            />
                        </div>
                    </div>
                </div>

                <div className="popup-form__group">
                    <div className="popup-form__row">
                        <div className="popup-form__col">
                            <Radio
                                name="dayTime"
                                value="1"
                                label={{ text: 'Morning'}}
                                form={props}
                                modifiers={['form']}
                            />
                            <Radio
                                name="dayTime"
                                value="2"
                                label={{ text: 'Afternoon'}}
                                form={props}
                                modifiers={['form']}
                            />
                        </div>
                    </div>
                </div>

                <div className="popup-form__group popup-form__group--section">
                    <div className="popup-form__label">Personal details</div>

                    <div className="popup-form__row">
                        <div className="popup-form__col">
                            <Input
                                name={`firstName`}
                                placeholder={`First Name`}
                                modifiers={['form']}
                                form={props}
                            />
                        </div>
                        <div className="popup-form__col">
                            <Input
                                name={`lastName`}
                                placeholder={`Last Name`}
                                modifiers={['form']}
                                form={props}
                            />
                        </div>
                    </div>

                    <div className="popup-form__row">
                        <div className="popup-form__col">
                            <Input
                                name={`phone`}
                                placeholder={`Phone`}
                                modifiers={['form']}
                                form={props}
                                type="tel"
                            />
                        </div>
                    </div>

                    <div className="popup-form__row">
                        <div className="popup-form__col">
                            <Input
                                name={`email`}
                                placeholder={`Email (optional)`}
                                modifiers={['form']}
                                form={props}
                                type="email"
                            />
                        </div>
                    </div>
                </div>

                <div className="popup-form__group pb-3">
                    <div className="popup-form__label">Your message</div>

                    <div className="popup-form__row">
                        <div className="popup-form__col">
                            <Textarea
                                name={`message`}
                                placeholder={`Add your message`}
                                form={props}
                            />
                        </div>
                    </div>
                </div>

                {status &&
                    <div className={'popup-form__alert pb-3'}>{status}</div>
                }

                <Turnstile
                    sitekey={process.env.TURNSTILE_SITE_KEY}
                    onVerify={(token) => {
                        this.setState({turnstileToken : token});
                    }}
                    theme={'light'}
                />

                <div className="popup-form__submit">
                    <Button
                        extraClass={extraClass}
                        title={`Submit details`}
                        modifiers={['solid', 'medium']}
                        chevron={true}
                        type="submit"
                        disabled={!isValid || !this.state.turnstileToken}
                        loading={isSubmitting}
                    />
                </div>
            </Form>
        );
    }

    render() {
        const { brand, ...rest } = this.props;
        let title;
        let hero = null;
        const text = 'Fill in your details below and we’ll get back to you';


        if (brand) {
            title = `Book your ${brand.name} service`;
            hero = { src: brand.banner };
        } else {
            title = `Book a service`;
        }

        const initialValues = {
            vehicleRegistration: '',
            brand: '',
            model: '',
            isLoanVehicle: true,
            dealer: '',
            date: '',
            dayTime: '2',
            firstName: '',
            lastName: '',
            phone: '',
            email: '',
            message: '',
            zapierUrl: window.location.href,
        };

        const validationSchema = Yup.object().shape({
            brand: Yup.string().required('Required'),
            model: Yup.string(),
            dealer: Yup.string().required('Required'),
            date: Yup.string().required('Required'),
            email: Yup.string().email('Invalid email'),
            firstName: Yup.string().required('Required'),
            lastName: Yup.string().required('Required'),
            phone: Yup.string().required('Required'),
            message: Yup.string().required('Required'),
        });

        return (
            <Layout
                hero={hero}
                title={title}
                text={text}
                {...rest}
            >
                <Formik
                    isInitialValid={isInitialValid}
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={this.handleSubmit}
                >
                    {formikProps => {
                        this.formik = formikProps;
                        return this.renderForm(formikProps);
                    }}
                </Formik>
            </Layout>
        );
    }
}

export default FormBookService;
